import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center p-5 bg-primary30" }
const _hoisted_2 = { class: "mb-12" }
const _hoisted_3 = { class: "w-full flex justify-center" }
const _hoisted_4 = { class: "w-full max-w-md bg-white rounded shadow-lg p-10 flex flex-col items-center text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "font-inter font-bold text-lg leading-7 text-[#333333] mb-4" }, " Esqueceu sua senha? ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-inter text-base text-gray-600 mb-8 max-w-xs sm:max-w-sm" }, " Insira o e-mail de acesso ao painel Minha Escala e enviaremos um link de recuperação para você. ", -1)
const _hoisted_7 = {
  class: "w-full mb-8",
  "data-testid": "forgot-password-email-input"
}
const _hoisted_8 = { class: "w-full flex flex-col gap-4" }
const _hoisted_9 = {
  class: "w-full mt-8 p-4 bg-[#FEF9E7] border border-[#F1C21B] rounded text-left",
  "data-testid": "forgot-password-doctor-app-notice"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-inter text-sm text-textPrimary mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "É médico(a)?"),
  /*#__PURE__*/_createTextVNode(" Recupere sua senha diretamente pelo aplicativo Minha Escala, na tela de login do app. ")
], -1)

import { ref, reactive } from 'vue'
import { useToast } from 'vue-toastification'
import * as yup from 'yup'
import Logo from '@/components/designSystem/Logo/index.vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import AppStoreBadges from '@/components/designSystem/AppStoreBadges/index.vue'
import Network from '@/Network'
import { useErrorToast } from '@/composables/useErrorToast'
import { getApiErrorStatus } from '@/utils/apiError'

const NEUTRAL_SUCCESS_MESSAGE =
  'Se o e-mail estiver cadastrado, enviaremos um link para redefinir a senha.'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const toast = useToast()
const { notifyError, notifyErrorMessage } = useErrorToast()
const email = ref('')
const isEmailError = ref(false)
const isLoading = ref(false)

const ForgotPasswordSchema = yup.object({
  email: yup.string().email('Email inválido').required('Email é obrigatório')
})

const rules = reactive({
  email: () => !isEmailError.value || 'Email inválido'
})

const validateEmail = async () => {
  try {
    await ForgotPasswordSchema.validateAt('email', { email: email.value })
    isEmailError.value = false
  } catch {
    isEmailError.value = true
  }
}

/**
 * Anti-enumeração de contas: a resposta de "enviado" e a de "e-mail não
 * cadastrado" (404 do backend) mostram a MESMA mensagem neutra. Rede, timeout,
 * 5xx e limite de tentativas continuam aparecendo como erro.
 */
const validateBeforeSend = async (): Promise<boolean> => {
  try {
    await ForgotPasswordSchema.validate({ email: email.value })
    return true
  } catch (error) {
    if (!(error instanceof yup.ValidationError)) throw error
    isEmailError.value = true
    notifyErrorMessage(error.message)
    return false
  }
}

const sendResetLink = async () => {
  isEmailError.value = false
  if (!(await validateBeforeSend())) return

  isLoading.value = true
  try {
    await Network.user.forgotPasswordRequest(email.value)
    toast.success(NEUTRAL_SUCCESS_MESSAGE)
  } catch (error) {
    if (getApiErrorStatus(error) === 404) {
      toast.success(NEUTRAL_SUCCESS_MESSAGE)
    } else {
      notifyError(error, 'Não foi possível enviar o link de recuperação. Tente novamente.')
      console.error(error)
    }
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo, {
        width: "160px",
        logo: "full_text_white"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(GenericInput, {
            type: "email",
            label: "Email",
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            isError: isEmailError.value,
            onValidate: validateEmail,
            rules: [rules.email]
          }, null, 8, ["modelValue", "isError", "rules"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(FilledButton, {
            text: "Enviar link",
            type: "submit",
            width: "100%",
            disabled: isLoading.value,
            loading: isLoading.value,
            onClick: sendResetLink,
            "data-testid": "forgot-password-submit-button"
          }, null, 8, ["disabled", "loading"]),
          _createVNode(_component_router_link, {
            to: "/",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(OutlineButton, {
                text: "Voltar para o Login",
                width: "100%",
                disabled: isLoading.value,
                "data-testid": "forgot-password-back-login-button"
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(AppStoreBadges, { class: "justify-center" })
        ])
      ])
    ])
  ]))
}
}

})